import { render, staticRenderFns } from "./NYTConnections.vue?vue&type=template&id=12630a44&scoped=true"
import script from "./NYTConnections.js?vue&type=script&lang=js&external"
export * from "./NYTConnections.js?vue&type=script&lang=js&external"
import style0 from "./NYTConnections.scss?vue&type=style&index=0&id=12630a44&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12630a44",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LoadingSpinner: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/common/LoadingSpinner.vue').default,NYTCard: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/NYTCard/NYTCard.vue').default,Advertisement: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/Advertisement/Advertisement.vue').default,NYTLatest: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/NYTLatest/NYTLatest.vue').default,TheSidebar: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/template/TheSidebar.vue').default})
